import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'

import AddressSelect from '@/components/DeliveryAddressBlock'

const DeliveryAddressBlock = ({
  deliveryAddresses,
  handleDeliveryAddressChange,
}) => {
  const { t } = useTranslation()

  const handleSelectAddress = useCallback(
    (_, selectedId) => {
      handleDeliveryAddressChange(selectedId)
    },
    [handleDeliveryAddressChange],
  )

  return (
    <div className="profile__main-block mt-5">
      <div className="profile__main-block__label">
        {t('checkout.step1.deliveryAddress')}
      </div>
      <Form.Item className="custom-form-item mt-4" name="deliveryAddress">
        <AddressSelect
          deliveryAddresses={deliveryAddresses}
          placeholder={t('myProfile.form.deliveryAddress.placeHolder')}
          onChange={handleSelectAddress}
        />
      </Form.Item>
      <div className="profile__main-block__description">
        {t('myProfile.deliveryAddressDesc')}
        &ensp;
        <span className="profile__main-block__description--bold">
          {t('myProfile.deliveryAddressDesc2')}
        </span>
      </div>
    </div>
  )
}

export default DeliveryAddressBlock
